import { render, staticRenderFns } from "./MapTraffic.vue?vue&type=template&id=47dfef5e&scoped=true&"
import script from "./MapTraffic.vue?vue&type=script&lang=js&"
export * from "./MapTraffic.vue?vue&type=script&lang=js&"
import style0 from "./MapTraffic.vue?vue&type=style&index=0&id=47dfef5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfef5e",
  null
  
)

export default component.exports